import type { CheckoutPlan } from '@/components/LeadCheckoutDialog';

// Produtos vendidos no site. Home, menu e /vsl leem daqui para preço e link não divergirem.
export const DORES_E_LESOES: CheckoutPlan = {
  id: 'dores-e-lesoes',
  name: 'Dores e Lesões na Amamentação',
  price: 'R$ 97,90',
  checkoutUrl: 'https://pay.hotmart.com/B99155485S?checkoutMode=10&bid=1793316026943',
};

export const AMAMENTACAO_NA_PRATICA: CheckoutPlan = {
  id: 'amamentacao-na-pratica',
  name: 'Amamentação na Prática',
  price: 'R$ 147,90',
  checkoutUrl: 'https://pay.hotmart.com/B99235195O?checkoutMode=10&bid=1793316083814&fromExitPopup=true',
};

export const AMAMENTACAO_DE_OURO: CheckoutPlan = {
  id: 'amamentacao-de-ouro-2',
  name: 'Amamentação de Ouro',
  price: 'R$ 247,90',
  checkoutUrl: 'https://pay.hotmart.com/T84177472Y?checkoutMode=10&bid=1793316161498&fromExitPopup=true',
};

export const COMUNIDADE: CheckoutPlan = {
  id: 'comunidade-amamentacao-na-pratica',
  name: 'Comunidade Amamentação na Prática',
  price: 'R$ 97,90',
  checkoutUrl: 'https://pay.hotmart.com/V87661851N?checkoutMode=10',
};

// Números oficiais da Rosane, iguais em todas as páginas
export const ROSANE_STATS = {
  duplas: '+15.000',
  anos: '25',
  profissionais: '+2.000',
  seguidores: '+70 mil',
};

// Combo da Black November: o cupom vai no próprio link (offDiscount) e já chega aplicado no checkout
export const COMBO_BLACK_NOV: CheckoutPlan = {
  id: 'combo-black-nov-26',
  name: 'Combo Amamentação na Prática',
  price: 'R$ 198,03',
  checkoutUrl: 'https://pay.hotmart.com/B102720652K?checkoutMode=10&offDiscount=BLACK30NOV26',
};

/** O que muda entre a home e as páginas de campanha (mesmo layout, outra oferta). */
export type Campaign = {
  id: string;
  /** Faixa no topo da página. */
  banner?: string;
  /** Fim da promoção (ISO com fuso). Com data, a faixa vira a tarja preta com contagem regressiva. */
  endsAt?: string;
  /** Selo da promoção no card da oferta. */
  badge?: string;
  plan: CheckoutPlan;
  offerHeading: string;
  offerTagline: string;
  priceFrom: string;
  installments: string;
  included: string[];
  /** Aviso de order bump no checkout. */
  bumpNote?: { title: string; text: string };
  finalCta: string;
  showCommunityCard: boolean;
  pageTitle?: string;
  /** Página de campanha não deve competir com a home no Google. */
  noindex?: boolean;
};

export const HOME_CAMPAIGN: Campaign = {
  id: 'home',
  plan: AMAMENTACAO_NA_PRATICA,
  offerHeading: 'Comece hoje',
  offerTagline: 'O Método PPS completo, no seu ritmo',
  priceFrom: 'De R$ 497,00',
  installments: 'ou parcelado em até 12x no cartão',
  included: [
    '10 módulos com mais de 100 aulas, gravadas com mães e bebês reais',
    'Método PPS completo',
    'Suporte especializado na área de membros',
    'Acesso vitalício',
    'Garantia de 7 dias',
  ],
  finalCta: 'Quero o Amamentação na Prática',
  showCommunityCard: true,
};

export const BLACK_NOV_CAMPAIGN: Campaign = {
  id: 'blacknov',
  banner: 'Combo Amamentação na Prática com 30% de desconto',
  endsAt: '2026-11-30T23:59:59-03:00',
  badge: 'Black November · 30% off',
  plan: COMBO_BLACK_NOV,
  offerHeading: 'Oferta Black November',
  offerTagline: 'Dois cursos em um combo, com 30% de desconto',
  priceFrom: 'De R$ 282,90',
  installments: 'ou 12x de R$ 20,48 no cartão',
  included: [
    'Curso Amamentação na Prática completo: 10 módulos e mais de 100 aulas',
    'Curso Fases do Desenvolvimento',
    'Os 5 bônus do Amamentação na Prática',
    'Suporte especializado na área de membros',
    'Garantia de 7 dias',
  ],
  bumpNote: {
    title: 'Comunidade por R$ 1,00',
    text: 'Na página de pagamento, marque a opção "Comunidade Amamentação na Prática" e entre no grupo com contato direto com a Rosane por R$ 1,00, em vez de R$ 97,90.',
  },
  finalCta: 'Quero o combo da Black',
  showCommunityCard: false,
  pageTitle: 'Black November | Combo Amamentação na Prática com 30% de desconto',
  noindex: true,
};
